import { escapeHtml, qrSvg, raffleEntryUrl } from './qr';

// Standalone A4 print document. All interpolated text is HTML-escaped;
// the QR is generated locally and has precisely the same URL as the label.
export function rafflePosterHtml(raffle, options = {}) {
  const url = raffleEntryUrl(raffle.id, options.origin || window.location.origin);
  const title = escapeHtml(options.title ?? raffle.title);
  const prize = escapeHtml(options.prize ?? raffle.prize ?? '');
  const safeUrl = escapeHtml(url);
  let qrGraphic;
  try { qrGraphic = qrSvg(url); }
  catch (_) { qrGraphic = '<p class="qr-fallback">QR unavailable. Use the URL below to enter.</p>'; }
  const titleLength = String(options.title ?? raffle.title ?? "").length;
  const titleSize = titleLength > 125 ? 21 : titleLength > 85 ? 25 : titleLength > 55 ? 29 : titleLength > 32 ? 34 : 52;
  const prizeSize = (options.prize ?? raffle.prize ?? "").length > 120 ? 12 : (options.prize ?? raffle.prize ?? "").length > 65 ? 15 : 19;
  return `<!doctype html>
<html lang="en"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">
<title>Event raffle · ${title}</title>
<style>
@page{size:A4 portrait;margin:0}*{box-sizing:border-box}html{background:#bbb}body{margin:0 auto;width:210mm;height:297mm;overflow:hidden;background:#f8f6f2;color:#1a1a1a;font-family:'DM Sans',Arial,sans-serif;border-left:6px solid #e8002d}
.page{height:100%;padding:12mm 15mm 10mm;display:flex;flex-direction:column;gap:4mm}
.brand{font:700 12pt 'Barlow Condensed',Arial,sans-serif;letter-spacing:.18em;text-transform:uppercase;color:#716e66}
.eyebrow{color:#a16b00;text-transform:uppercase;font-weight:700;font-size:11pt;letter-spacing:.19em}
h1{font:900 ${titleSize}pt/1.08 'Barlow Condensed','Arial Narrow',sans-serif;text-transform:uppercase;margin:0;overflow-wrap:anywhere;max-height:60mm}
.rule{height:4px;background:linear-gradient(90deg,#f9b000,#e8002d 60%,transparent)}
.prize{font-size:${prizeSize}pt;font-weight:700;overflow-wrap:anywhere;max-height:36mm}
.qr{width:70mm;height:70mm;margin:1mm auto;background:white;padding:3mm;border-radius:5px;box-shadow:0 2px 14px #0002}
.qr svg{display:block;width:100%;height:100%}.qr-fallback{margin:10mm auto;text-align:center;font-weight:700;font-size:15pt}
.steps{display:grid;gap:3mm}.step{border:1px solid #ddd3c8;background:#f0ede7;padding:2.5mm 4mm;font-size:14pt;display:flex;align-items:center;gap:5mm}
.num{font:900 24pt 'Barlow Condensed',Arial,sans-serif;color:#bc8100;min-width:8mm}
.footer{margin-top:auto;border-top:2px solid #c8c2ba;padding-top:4mm;text-align:center}.url{font-size:12pt;font-weight:700;overflow-wrap:anywhere;word-break:break-word}.fine{margin-top:3mm;font-size:9pt;color:#777}
@media print{html{background:white}body{margin:0;-webkit-print-color-adjust:exact;print-color-adjust:exact}}
</style></head><body><main class="page"><div class="brand">Bryggeriet Ångkvarn presents</div><div class="eyebrow">Event raffle · Free entry</div>
<h1>${title}</h1><div class="rule"></div><div class="prize">${prize || 'One winner · One chance per email'}</div>
<div class="qr">${qrGraphic}</div><div class="steps"><div class="step"><span class="num">1</span>Scan this QR code or visit the URL below</div><div class="step"><span class="num">2</span>Enter your name and email</div><div class="step"><span class="num">3</span>One entry per email · One winner</div></div>
<footer class="footer"><div class="url">${safeUrl}</div><div class="fine">Free to enter · Winner announced by the host · Bryggeriet Ångkvarn</div></footer></main></body></html>`;
}

export function printRafflePoster(raffle, options = {}) {
  const tab = window.open('', '_blank');
  if (!tab) return false;
  try {
    tab.document.open();
    tab.document.write(rafflePosterHtml(raffle, options));
    tab.document.close();
    // Host chooses print via browser Print (Ctrl+P), after visual inspection.
    return true;
  } catch (error) {
    try { tab.close(); } catch (_) { /* already blocked */ }
    return false;
  }
}
